import { createEnumGuard } from 'src/models/enumGuard';
import { ModuleNameEnum as _ModuleName } from 'src/models/module/enums';

export const ModuleNameRunType = createEnumGuard(Object.values(_ModuleName) as _ModuleName[]);
